<template>
  <div class="content-wapper">
    <el-row class="navigation">
      <el-col align="left">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '' }">知识产权综合服务</el-breadcrumb-item>
          <el-breadcrumb-item>威海市专利查询</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6">
        <el-row class="left-img">
          <img src="@/assets/images/whszl/whszlcx.png"/>
        </el-row>
        <el-row class="menu-box" style="height: 340px;">
          <el-menu default-active="1"
                   class="el-menu-vertical-demo"
                   text-color="#000"
                   active-text-color="#ffd04b"
                   @select="handleSelect">
            <el-menu-item index="1">
              <i class="el-icon-link"></i>
              <span slot="title">威海市有效发明专利查询</span>
            </el-menu-item>
            <el-menu-item index="2">
              <i class="el-icon-link"></i>
              <span slot="title">威海市PCT专利查询</span>
            </el-menu-item>
          </el-menu>
        </el-row>
      </el-col>
      <el-col :span="18" class="right-box-row" style="height: auto;" v-show="topTableView" @click="reload()">
        <yxfmzlcx></yxfmzlcx>
      </el-col>
      <el-col :span="18" class="right-box-row" style="height: auto;" v-show="bottomTableView" @click="reload()">
        <pctzlsqcx></pctzlsqcx>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import yxfmzlcx from "./yxfmzlcx";
  import pctzlsqcx from "./pctzlsqcx";
  export default {
    name: "Whszl",
    components: {
      yxfmzlcx,
      pctzlsqcx,
    },
    data() {
      return {
        // 遮罩层
        loading: false,
        // 总条数
        total: 0,
        list:[],
        queryParams:{
          pageNum:1,
          pageSize:10
        },
        topTableView: true,
        bottomTableView: false,
      };
    },
    created() {
      this.getList();
    },
    methods: {
      refresh(){
        this.getList();
      },
      openDetail(row) {
      },
      getList(){
      },
      handleSelect(key, keyPath) {
        if(key=='1'){
          this.topTableView = true;
          this.bottomTableView = false;
        }else if(key=='2'){
          this.bottomTableView = true;
          this.topTableView = false;
        }
      },
	  reload(){
        this.$forceUpdate();
	  }
    }
  }
</script>

<style scoped>
  .content-wapper {
    margin-top: 5px;
    padding: 10px;
  }

  .navigation{
    padding:25px 15px;
    line-height: 20px;
    height: 60px;
    background-color: #F5F5F5;
    margin-bottom: 15px;
  }
  .left-img img{
    width: 100%;
  }
  /deep/.el-menu{
    text-align: left;
    background-color:#FAFAFA;
    border:0;
  }
  .right-box-row{
    border: 1px solid #cccccc;
    padding: 10px 15px;
  }
  .menu-box{
    background-color: #FAFAFA;
    padding: 15px 10px;
  }

</style>